import * as React from "react";
import type { SVGProps } from "react";
const SvgFileReturn01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.9 21.6H5.7a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v5.4m-4.757 10.2L11.7 17.946m0 0 2.332-2.346M11.7 17.946h7.227a1.773 1.773 0 0 0 0-3.546H16.5"
    />
  </svg>
);
export default SvgFileReturn01;
